export const flattenMatterFolderOptions = (nodes = [], prefix = "") => {
  const options = [];
  nodes.forEach((node) => {
    const record = node?.record || node;
    const isFolder = record?.type === "folder" || node?.type === "folder";
    const title = node?.title || record?.name || record?.title;
    const value = record?.id || node?.key || record?.unique_id;
    if (isFolder && value && title) {
      const label = prefix ? `${prefix} / ${title}` : title;
      options.push({ value: String(value), label });
      const children = Array.isArray(node?.children) ? node.children : [];
      options.push(...flattenMatterFolderOptions(children, label));
    } else if (Array.isArray(node?.children)) {
      options.push(...flattenMatterFolderOptions(node.children, prefix));
    }
  });
  return options;
};

export const generatedDocumentId = (doc) =>
  doc?.id ?? doc?.document_id ?? doc?.unique_id ?? "";

export const preserveOffPageDocumentSelection = (
  previousKeys = [],
  nextKeys = [],
  currentPageRecords = []
) => {
  const currentPageDocumentKeys = new Set(
    (currentPageRecords || [])
      .filter((record) => record?.type !== "folder")
      .map((record) => String(record?.id ?? record?.key ?? record?.unique_id ?? ""))
  );
  if (!currentPageDocumentKeys.size) {
    return nextKeys || [];
  }

  const retainedOffPageKeys = (previousKeys || []).filter(
    (key) => !currentPageDocumentKeys.has(String(key))
  );
  const nextCurrentPageKeys = (nextKeys || []).filter((key) =>
    currentPageDocumentKeys.has(String(key))
  );
  return [...new Set([...retainedOffPageKeys, ...nextCurrentPageKeys])];
};
